import { useState } from 'react'
import { useNavigate, useSearchParams, Link } from 'react-router'
import { acceptInvite } from '../api/client'

const cardStyle: React.CSSProperties = {
  background: '#fff',
  border: '1px solid #e5e7eb',
  borderRadius: 8,
  padding: 32,
  maxWidth: 380,
  margin: '80px auto',
}

const inputSt: React.CSSProperties = {
  width: '100%',
  boxSizing: 'border-box',
  padding: '8px 12px',
  border: '1px solid #d1d5db',
  borderRadius: 6,
  fontSize: 14,
  marginBottom: 12,
}

const btnStyle: React.CSSProperties = {
  width: '100%',
  padding: '8px 14px',
  borderRadius: 6,
  border: 'none',
  cursor: 'pointer',
  fontSize: 14,
  fontWeight: 500,
  background: '#2563eb',
  color: '#fff',
}

export default function AcceptInvite() {
  const [params] = useSearchParams()
  const token = params.get('token') || ''
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [done, setDone] = useState(false)
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError(null)
    if (password.length < 8) {
      setError('Password must be at least 8 characters.')
      return
    }
    if (password !== confirm) {
      setError("Passwords don't match.")
      return
    }
    setLoading(true)
    try {
      await acceptInvite(token, password)
      setDone(true)
      setTimeout(() => navigate('/login'), 2000)
    } catch {
      setError('This invite link is invalid or has expired.')
    } finally {
      setLoading(false)
    }
  }

  if (!token) {
    return (
      <div style={cardStyle}>
        <p style={{ color: '#dc2626' }}>Missing invite token. Check the link from your invite email.</p>
      </div>
    )
  }

  if (done) {
    return (
      <div style={cardStyle}>
        <p style={{ color: '#065f46' }}>Password set — redirecting to sign in…</p>
      </div>
    )
  }

  return (
    <div style={cardStyle}>
      <h2 style={{ margin: '0 0 20px', fontSize: 20 }}>Set your password</h2>
      <form onSubmit={handleSubmit}>
        <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 4 }}>New password</label>
        <input style={inputSt} type="password" value={password} onChange={e => setPassword(e.target.value)} required autoFocus />
        <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 4 }}>Confirm password</label>
        <input style={inputSt} type="password" value={confirm} onChange={e => setConfirm(e.target.value)} required />
        {error && <p style={{ color: '#dc2626', fontSize: 13, margin: '0 0 12px' }}>{error}</p>}
        <button style={btnStyle} type="submit" disabled={loading}>
          {loading ? 'Setting password…' : 'Set password & sign in'}
        </button>
      </form>
      <p style={{ fontSize: 12.5, color: '#6b7280', marginTop: 16 }}>
        Already set your password? <Link to="/login">Sign in</Link>.
      </p>
    </div>
  )
}
